import { format } from "date-fns";
import { parseDayIdToLocalDate } from "@/react/utils/dates/dayId";
import { DATE_FORMAT } from "../constants";

export const formatDateLabel = (
  dateGrouping: string | undefined,
  dateValue: string | number,
): string => {
  const date = parseDayIdToLocalDate(String(dateValue));

  switch (dateGrouping) {
    case "daily":
      // Example: Wed, Apr 2, 2025
      return format(date, "EEE, MMM d, yyyy");
    case "weekly": {
      const endDate = new Date(date);
      endDate.setDate(date.getDate() + 6);
      // Example: Apr 1 – Apr 7, 2025 (en dash, year only on ending label)
      return `${format(date, "MMM d")} – ${format(endDate, "MMM d, yyyy")}`;
    }
    case "monthly":
      // Example: Dec, 2025
      return format(date, "MMM, yyyy");
    default:
      return format(date, DATE_FORMAT);
  }
};
